import IMask from 'imask';

(function ($) {
    $(document).ready(function () {
        var phone_mask = document.getElementById('phone_mask');
        if (phone_mask) {
            var phoneMask = IMask(
                document.getElementById('phone_mask'), {
                    mask: '+{1}0000000000'
                });
        }

        function handle_form_preferences (form, _callback) {
            // Enter loading state
            form.addClass('loading');
            let form_data = new FormData();
            // Add form action
            form_data.append('action', form.attr('data-action'));
            // Add all fields
            form.serializeArray().reduce(function (obj, item) {
                form_data.append(item.name, item.value);
            }, {});

            // ajax
            $.ajax({
                url: ajaxurl,
                data: form_data,
                type: 'POST',
                processData: false,
                contentType: false,
                success: function (r, textStatus, jqXHR) {
                    _callback(r);
                }
            });
        }

        document.querySelector('input').addEventListener('invalid',
            function (event) {
                event.preventDefault();
                $(this).closest('form').submit();
            });

        $('form.auto[data-action="ajax_update_preferences"]').submit(function (e) {
            e.preventDefault();
            let form = $(this);
            $('.mailchimp-form__info--new').hide();
            $('.mailchimp-form__info--pending').hide();
            $('.mailchimp-form__info--update').hide();
            if (!validate_form_preference(form)) {
                e.preventDefault();
                form.addClass('gform_validation_errors');
                return false;
            }
            handle_form_preferences(form, function (response) {
                form.removeClass('loading');
                response = JSON.parse(response);
                if (response.success) {
                    form.addClass('success');
                    if (response.hasOwnProperty('redirect')) {
                        window.location.replace(response.redirect);
                    }
                    if (response.mailchimp == 'pending') {
                        $('.mailchimp-form__info--pending').show();
                        $('html, body').animate({
                            scrollTop: $('.mailchimp-form').offset().top
                        }, 0);
                    }
                    if (response.mailchimp == 'subscribed') {
                        $('.mailchimp-form__info--update').show();
                        $('.gform_footer__more_btn--unsubscribed').show();
                        $('html, body').animate({
                            scrollTop: $('.mailchimp-form').offset().top
                        }, 0);
                    }
                    if (response.mailchimp == 'unsubscribed') {
                        $('.mailchimp-form__info--update').show();
                        $('.gform_footer__more_btn--unsubscribed').hide();

                        $('html, body').animate({
                            scrollTop: $('.mailchimp-form').offset().top
                        }, 0);
                    }
                    $('.action_mailchimp').val('update');

                }
            });

            return false;
        });

        function validate_form_preference (form) {
            form.removeClass('gform_validation_errors');
            form.find('.gfield').removeClass('gfield_error');

            let valid = true;
            form.find('.input_phone').each(function () {
                let input = $(this);
                let parent = input.parents('.gfield');
                let pattern = /^\+[1-9]\d{10,14}$/;
                if (input.val().trim() != '' && !pattern.test(input.val())) {
                    parent.addClass('gfield_error');
                    valid = false;
                }
            });
            form.find('#sms').each(function () {
                let input = $(this);
                let parent = input.parents('.field');
                var pattern = /^\+[1-9]\d{10,14}$/;

                if (input.is(':checked') && ($('.input_phone').val().trim() == '' || !pattern.test($('.input_phone').val()))) {
                    parent.addClass('error');
                    valid = false;
                }
            });
            form.find('.required').each(function () {
                let input = $(this);
                let parent = input.parents('.gfield');
                let pattern = '';
                switch (input.attr('type')) {
                    case 'text':
                    case 'tel':
                        pattern = /^\+[1-9]\d{10,14}$/;
                        if (!pattern.test(input.val())) {
                            parent.addClass('gfield_error');
                            valid = false;
                        }
                        break;
                    case 'email':
                        pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

                        if (input.val().trim() == '' || !pattern.test(input.val())) {
                            parent.addClass('gfield_error');
                            valid = false;
                        }
                        break;

                    case 'radio':
                    case 'checkbox':
                        let checkbox_name = input.attr('name');
                        if (!$('input[name="' + checkbox_name + '"]').is(':checked')) {
                            parent.addClass('gfield_error');
                            valid = false;
                        }
                        break;
                }
                if (input.is('textarea')) {
                    if (!input.val()) {
                        parent.addClass('gfield_error');
                        valid = false;
                        return valid;
                    }
                }
            });

            return valid;
        }

        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('status')) {
            let param = searchParams.get('status');
            if (param == 'modified') {
                $('.mailchimp-form__message').show();
            }

        }
        $(document).on('click', '.gform_footer__more_btn--notme', function (e) {
            e.preventDefault();
            $('.action_mailchimp').val('notme');
            $('.mailchimp-form__preferences').submit();
        });
        $(document).on('click', '.gform_footer__more_btn--unsubscribed', function (e) {
            e.preventDefault();
            document.getElementById('infolettre').checked = false;
            $('.action_mailchimp').val('unsubscribed');
            $('.mailchimp-form__preferences').click();
        });
    });
})(jQuery);
